import { DateTime } from 'luxon';

import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as BinTrashIcon } from 'assets/icons/trash.svg';
import './AssignmentAndEventListCard.scoped.scss';

const Edit = EditIcon as React.FC<React.SVGProps<SVGSVGElement>>;
const BinTrash = BinTrashIcon as React.FC<React.SVGProps<SVGSVGElement>>;

interface Props {
  name: string;
  date: string;
  onEdit: () => void;
  onDelete: () => void;
}

const AssignmentAndEventListCard: React.FC<Props> = ({ name, date, onEdit, onDelete }) => {
  const parseDate = (dateToParse: string) => {
    const checkDate = DateTime.fromISO(dateToParse);
    const today = DateTime.now().startOf('day');
    if (today < checkDate) return 'Just created';
    return `Opened ${checkDate.toFormat('dd/MM')}`;
  };

  return (
    <div className="container">
      <div className="wrapper">
        <h1 className="title">{name}</h1>
        <div className="icons">
          <Edit color="#6e7e97" onClick={onEdit} height={16} width={16} />
          <BinTrash color="#6e7e97" onClick={onDelete} height={16} width={16} />
        </div>
      </div>
      <h4 className="created-at">{parseDate(date)}</h4>
    </div>
  );
};

export default AssignmentAndEventListCard;
